module.exports = __webpack_public_path__ + "img/two.e4b5becb.png";